import { createAppSettingsRouteWithSettingType } from './helpers/routeHelpers';
import { Environment, IntegrationType, SettingType } from './types';

// Endpoints
export const USER_ENDPOINT = 'api/user';

// Userflow

export const USERFLOW_DEMO_FLOW_ID = '28b3ff48-36e2-4ab6-b8ad-cffcae9d326a';

// GA4

export const GA_MEASUREMENT_ID = 'G-JE90VWW2GP';

// Google Ad Words

export const GAW_PROPERTY_ID = 'AW-10829754623';

export const GOOGLE_ADS_CONVERSION_ID = `${GAW_PROPERTY_ID}/VNmICIf8gI8YEP_hg6wo`;

// LinkedIn

export const LINKED_IN_CONVERSION_ID = 6281978;

// Stack Overflow

export const STACK_OVERFLOW_CONVERSION_PIXEL = 'https://pubads.g.doubleclick.net/activity;xsp=5028903;';

// Play Console

export const PLAY_CONSOLE_URL = 'https://play.google.com/console';

// Documentation

export const API_DOCUMENTATION_URL = 'https://api-docs.runway.team';
export const BUMP_VERSION_DOCS_URL = 'https://docs.runway.team/automations/types-of-automations#bump-version-in-code';

// Marketing site
export const MARKETING_SITE_URL = 'https://www.runway.team';

// Marketing site demo url

export const MARKETING_SITE_DEMO_URL = 'https://www.runway.team/demo';

// App signup url

export const APP_SIGNUP_URL = 'https://app.runway.team/signup';

// Stape ID cookie constant
export const STAPE_ID_COOKIE_KEY = 'stapeid';

// Test orgs

export const TEST_ORG_IDS = [
    'tab',
    'test-org',
    'runway-org',
    'isabel-org',
    'keegan-org',
    'ale-org',
    'adrian-org',
    'workflow-test-org',
    'justin-org',
];

// Org IDs that should send BD events to LogRocket
export const BD_LOGROCKET_ORG_IDS = new Set(['org_zNc8uQX7', 'org_fnUuu8FK', 'org_6UDWDTLs']);

// Integrations

export const integrationAuthRedirectUri: (
    orgIdParam: string,
    appIdParam: string,
    integrationType: IntegrationType,
    baseUrl?: string,
) => string = (orgIdParam, appIdParam, integrationType, baseUrl = window.location.origin) => {
    const integrationsRoute = createAppSettingsRouteWithSettingType(orgIdParam, appIdParam, SettingType.Integrations);
    return `${baseUrl}${integrationsRoute}/${integrationType}`;
};

/* Static redirect uri required for certain integrations. This redirect is handled by the server.
 */

export const postinstallRedirectUri: (integrationType: IntegrationType, forceDev?: boolean) => string = (
    integrationType,
    forceDev = false,
) => {
    const env = process.env.NODE_ENV as Environment;

    var baseUrl = 'https://listen.runway.team';
    if (env === Environment.Development || forceDev) {
        baseUrl = 'https://staging-listen.runway.team';
    }

    // Need to special case some integrations because they only allow a single redirect URI

    switch (integrationType) {
        case IntegrationType.GitHubVCS:
        case IntegrationType.GitHubCI:
            return `${baseUrl}/integrations/github/postinstall`;
        case IntegrationType.AzureCI:
        case IntegrationType.AzureIT:
        case IntegrationType.AzureVCS:
            return `${baseUrl}/integrations/azure/postinstall`;
        case IntegrationType.GitLabCI:
        case IntegrationType.GitLabVCS:
            return `${baseUrl}/integrations/gitlab/postinstall`;
        default:
            return `${baseUrl}/integrations/${integrationType}/postinstall`;
    }
};

// Bitbucket Integration
export const BITBUCKET_OAUTH_CLIENT_ID_DEV = 'gHjPF53uWFDEwy2dRX';
export const BITBUCKET_OAUTH_CLIENT_ID = 'WRRd8Wk43WeR66fWrG';
export const BITBUCKET_AUTHORIZE_BASE_URL = 'https://bitbucket.org/site/oauth2/authorize';

// GitHub Integration

export const GITHUB_APP_INSTALLATION_BASE_URL_DEV = 'https://github.com/apps/RunwayHelperDev/installations/new';
export const GITHUB_APP_INSTALLATION_BASE_URL_PROD = 'https://github.com/apps/runway-github/installations/new';

// GitLab Integration

export const GITLAB_CLIENT_ID_DEV = 'f40bf710e528ab0dee538a919376a284c367b375ecb840613ee41f919f524e70';
export const GITLAB_CLIENT_ID_PROD = '3dc6e8ece16f1699362d7bb66be6fef6e4f7f389af839b4c366ff42f5c687cdd';
export const GITLAB_AUTHORIZE_BASE_URL = 'https://gitlab.com/oauth/authorize'; // TODO - in future will need to handle subdomains

// Slack Integration

export const SLACK_CLIENT_ID_DEV = '1138953648259.1321879998132';
export const SLACK_CLIENT_ID_PROD = '1138953648259.1460432069842';
export const SLACK_AUTHORIZE_BASE_URL = 'https://slack.com/oauth/v2/authorize'; // redirect the user to authorize your requested scopes

// Jira Integration

export const JIRA_CLIENT_ID_DEV = 'pAsPos4d0knmPN0CS2qwcl9tOVjIE5Ex';
export const JIRA_CLIENT_ID_PROD = 'orpSHfmaHs1SNZk9VIsLaFd9a46ZCZwO';
export const JIRA_APP_INSTALLATION_BASE_URL = 'https://auth.atlassian.com/authorize';

// Google Play Store Integration

export const GOOGLE_PLAY_CLIENT_ID_DEV = '652402110286-vnjgd0guce1hqgoubqvguji1v20f2h14.apps.googleusercontent.com';
export const GOOGLE_PLAY_CLIENT_ID_PROD = '';
export const GOOGLE_PLAY_INSTALLATION_BASE_URL = 'https://accounts.google.com/o/oauth2/auth';

// Linear

export const LINEAR_APP_INSTALLATION_BASE_URL = 'https://linear.app/oauth/authorize';
export const LINEAR_CLIENT_ID_DEV = '11fea44d93ec3e48e14e91f21538f8a3';
export const LINEAR_CLIENT_ID_PROD = '69aaad6da3ce62bc099cb3cd629b257c';

// Asana
export const ASANA_APP_INSTALLATION_BASE_URL = 'https://app.asana.com/-/oauth_authorize';
export const ASANA_CLIENT_ID_DEV = '1201503316877686';
export const ASANA_CLIENT_ID_PROD = '1202454571429099';

// Azure
// TODO: Need to update these values? cc Isabel
export const AZURE_APP_INSTALLATION_BASE_URL = 'https://app.vssps.visualstudio.com/oauth2/authorize';
export const AZURE_CLIENT_ID_DEV = '77B323AD-7C35-43B0-8098-8A2F470EE870';
export const AZURE_CLIENT_ID_PROD = '7368E856-2262-4668-BF3E-86F189367BAC';

// Amplitude

export const AMPLITUDE_API_KEY_DEV = 'a7fda50a7fc6f3426074af0f654e75ad';
export const AMPLITUDE_API_KEY_PROD = 'decfeb34a68c17d4c9eb474731dd3398';

// Amplitude Experiments Deployment Keys

export const AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY_DEV = 'client-qzCPaurngpSe2fhLIWqE12EUu7RKPFQm';
export const AMPLITUDE_EXPERIMENT_DEPLOYMENT_KEY_PROD = 'client-3Ct764O6hlxxHmHQE71QzzVerfj03ACt';

//Monday
export const MONDAY_APP_INSTALLATION_BASE_URL = 'https://auth.monday.com/oauth2/authorize';
export const MONDAY_CLIENT_ID_DEV = '6ede389cf9aaee5b8c21614976cfb4f8';
export const MONDAY_CLIENT_ID_PROD = '1f69274505f7a6dfd3a27c6621f4a969';

// Azure Active Directory (Microsoft Teams)
export const AZURE_AD_APP_INSTALLATION_BASE_URL = 'https://login.microsoftonline.com/common/oauth2/v2.0/authorize';
export const AZURE_AD_TENANT_ID = '67520f1d-ae0a-4725-8149-2226aaf3534d'; // Same for Prod and Dev
export const AZURE_AD_CLIENT_ID_DEV = 'e3e9304f-9ed9-4a71-b4f7-8c07bb0958eb';
export const AZURE_AD_CLIENT_ID_PROD = 'fe9fc1a8-997c-40b8-9b00-85b26a66caa5';

// Google OAuth
export const GOOGLE_OAUTH_APP_INSTALLATION_BASE_URL = 'https://accounts.google.com/o/oauth2/auth';
export const GOOGLE_OAUTH_CLIENT_ID = '666765370075-2s42so0fpnr674ftcuu78rs8qr6abhmj.apps.googleusercontent.com';

// General
export const INACTIVITY_PERIOD_MS = 259200000; // 72 hours
export const INACTIVITY_PERSON_MS_RUNWAY_ADMINS = 86400000; // 24 hours

export const DEFAULT_ROLLOUT_SEQUENCE = [1, 2, 5, 10, 20, 50, 100];

// Release Overview Grid
export const GRID_GAP = 20;
export const GRID_CARD_MIN_WIDTH = 280;
export const GRID_MIN_WIDTH = GRID_CARD_MIN_WIDTH * 2 + GRID_GAP;

export const FROM_ROTATION = 'FROM_ROTATION';

export const PLATFORM_AVAILABILITY_MESSAGE = 'This platform does not support direct binary installation.';

// Errors
export const ERROR_PERMISSION_DENIED = 'User not allowed to perform action';

export const USER_FRIENDLY_ERRORS = [ERROR_PERMISSION_DENIED];
